import { Container, Row } from "reactstrap";
import { LeafletMapTitle, MapTitle } from "../../../../constants";
import AustraliaMap from "./AustraliaMap";
import IndiaMap from "./IndiaMap";
import UsaMap from "./UsaMap";
import WorldMap from "./WorldMap";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";

const LeafletMapsContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={LeafletMapTitle} parent={MapTitle} />
      <Container fluid>
        <Row>
          <WorldMap />
          <UsaMap />
          <IndiaMap />
          <AustraliaMap />
        </Row>
      </Container>
    </>
  );
};
export default LeafletMapsContainer;
